/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FacilityPhysicianInput
 */
export interface FacilityPhysicianInput {
    /**
     * 
     */
    physician_name: string;
    /**
     * 
     */
    physician_npi: string;
    /**
     * 
     */
    is_default?: boolean;
}

/**
 * Check if a given object implements the FacilityPhysicianInput interface.
 */
export function instanceOfFacilityPhysicianInput(value: object): value is FacilityPhysicianInput {
    if (!('physician_name' in value) || value['physician_name'] === undefined) return false;
    if (!('physician_npi' in value) || value['physician_npi'] === undefined) return false;
    return true;
}

export function FacilityPhysicianInputFromJSON(json: any): FacilityPhysicianInput {
    return FacilityPhysicianInputFromJSONTyped(json, false);
}

export function FacilityPhysicianInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacilityPhysicianInput {
    if (json == null) {
        return json;
    }
    return {
        
        'physician_name': json['physician_name'],
        'physician_npi': json['physician_npi'],
        'is_default': json['is_default'] == null ? undefined : json['is_default'],
    };
}

export function FacilityPhysicianInputToJSON(json: any): FacilityPhysicianInput {
    return FacilityPhysicianInputToJSONTyped(json, false);
}

export function FacilityPhysicianInputToJSONTyped(value?: FacilityPhysicianInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'physician_name': value['physician_name'],
        'physician_npi': value['physician_npi'],
        'is_default': value['is_default'],
    };
}

